var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topics-wrapper"},[_c('TopicTitle'),_c('TopicDeck',{staticClass:"flex-fill"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }